import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20840 18504"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#fefefe;stroke-width:230.945}.fil0{fill:#231f20}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974613589696">
        <path
          d="M11950 6872c-70 460-236 871-432 1189-96 157-204 303-297 412-98 114-169 208-226 295-55 85-93 155-118 203-25 49-38 75-38 75l-193-97s14-28 42-79c29-52 73-127 136-218 61-89 149-199 247-306 101-111 194-233 292-382 193-295 362-680 442-1116 39-218 57-449 46-682-14-231-43-477-64-716-182-1929-364-3857-364-3857s236 1922 472 3845c28 242 63 477 84 721 18 242 6 483-29 713zm526-926-479-4415c-51-471-310-894-705-1154-529-349-1215-349-1744 0-395 260-654 683-705 1154l-479 4415c-114 1053 228 2097 924 2876 216 241 372 530 434 847v1c220-74 454-115 698-115s479 41 698 115c62-318 218-607 434-848 697-779 1038-1823 924-2876zM5414 12892c434-169 873-231 1246-220 184 5 364 25 506 51 147 28 265 43 368 48 101 6 181 4 235 2 54-4 84-6 84-6l12 216s-31 1-90 3c-59 1-146 1-256-9-108-8-246-29-388-60-148-32-299-52-478-63-351-20-769 27-1187 177-209 74-417 174-613 300-194 128-392 275-589 413l-3158 2244s1547-1165 3094-2331c196-145 382-293 582-433 201-137 416-247 632-332zm-1065 8L765 15523c-382 279-619 714-647 1187-2 29-3 59-3 88-1 599 336 1151 875 1422 423 212 919 224 1352 33l4063-1793c969-427 1703-1245 2029-2237 101-308 273-587 517-800-173-153-326-336-448-547-122-212-204-435-250-662-306 105-634 114-951 48-1023-214-2098 13-2953 638zM13896 15542c-363-290-636-640-814-969-87-161-161-327-208-463-50-142-96-251-143-342-45-91-87-159-116-205-30-45-47-70-47-70l181-119s17 27 48 77c30 50 73 126 120 226 47 98 98 228 142 366 46 144 105 285 185 445 158 315 407 653 746 940 169 143 359 274 567 381 207 104 434 202 652 303l3522 1614-3566-1514c-223-97-444-185-666-288-219-105-422-236-603-382zm539 918 4064 1793c432 191 928 179 1351-33 566-284 909-878 872-1510-28-473-265-908-647-1187l-3584-2623c-855-625-1930-852-2953-638-317 66-644 57-951-48-46 227-128 450-250 662-122 211-275 394-448 547 244 213 416 492 517 800 327 992 1060 1810 2029 2237zM10420 9914c-1024 0-1854 831-1854 1855s830 1855 1854 1855 1855-831 1855-1855-831-1855-1855-1855z"
          className="fill stroke1"
          style={{
            strokeWidth: 230.945,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
